module.exports = __webpack_public_path__ + "img/hero.f45cf8b9.webp";